import './common/fontfamily.css';
import './common/color.css';
import "animate.css/animate.min.css";
import { BrowserRouter } from 'react-router-dom';
import Router from './Router';

function App() {
  return (
    <div className="bg-body relative">
			<BrowserRouter>
				<Router />
			</BrowserRouter>
		</div>
  );
}

export default App;
